module.exports = __webpack_public_path__ + "static/media/Allyn_Stott.e0e439dd.png";